import { z } from 'zod'

export const createProfileAddressSchema = z.object({
  label: z.string().trim().min(1).max(50),
  route_id: z.number().int().positive(),
  address: z.string().trim().min(1).max(200),
  additional_address: z.string().trim().max(100),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  is_favorite: z.literal(true),
})

export const profileAddressSchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  route_id: z.number().int(),
  address: z.string(),
  additional_address: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  is_favorite: z.boolean(),
})

export type CreateProfileAddressInput = z.infer<typeof createProfileAddressSchema>
export type ProfileAddress = z.infer<typeof profileAddressSchema>
